import React, { useEffect } from "react";
import { Button, Icon } from "semantic-ui-react";
import { useParams, useHistory } from "react-router-dom";
import { useCategory, useTable } from "../../hooks";
import { ListCategories } from "../../components/Client";
import { CustomerSelector, DeliveryInfo, CartButton } from "../../components/Admin";
import { getTablePlace } from "../../utils/table";

export function TableMenuCategories() {
  const { id } = useParams();
  const { loading, categories, getCategories } = useCategory();
  const { table, getTable, setTableCustomer, setTableDelivery } = useTable();
  const history = useHistory();

  useEffect(() => {
    getCategories(true);
    getTable(id);
  }, []);

  // "Selecciona un cliente" debajo del nombre de la mesa, como en
  // Restaurant.pe. Opcional; pasa a la cuenta al generarla.
  const onChangeCustomer = async (customer) => {
    await setTableCustomer(id, customer ? customer.id : null);
    getTable(id);
  };

  const goToTable = () => history.push(`/admin/table/${id}`);
  const goToCart = () => history.push(`/admin/table/${id}/menu/cart`);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button icon labelPosition="left" onClick={goToTable}>
          <Icon name="arrow left" />
          Regresar a la mesa
        </Button>
        <CartButton onClick={goToCart} />
      </div>

      {table && (
        <div className="table-menu-header">
          <h2>{getTablePlace(table)}</h2>
          {table.kind === "DELIVERY" && (
            <DeliveryInfo
              title={getTablePlace(table)}
              channel={table.current_delivery_channel}
              fee={table.current_delivery_fee}
              onChange={async (channel, fee) => {
                await setTableDelivery(id, channel, fee);
                getTable(id);
              }}
            />
          )}{" "}
          <CustomerSelector
            attention
            customer={table.current_customer_data}
            onChange={onChangeCustomer}
          />
        </div>
      )}

      <h3>Categorias</h3>
      {loading ? <p>Cargando</p> : <ListCategories categories={categories} />}
    </div>
  );
}
